<template>
<b-container fluid>
    <div class="body-wrapper">
        <div class="body-title">
            <h5 style="color:#2284ab">Exemption Application - Employer Mapping</h5>
        </div>
        <b-alert :show = "showDismissibleAlert" dismissible 
            @dismissed="showDismissibleAlert=false"
            
            :variant="variant">
            {{alertText}}
        </b-alert>
        <div class="body-content">
            <b-card no-body>
                <b-row>
                    <b-col md="6">
                      <b-input-group prepend="Map Employer" size="sm">
                        <b-input-group-prepend>
                        <b-form-select v-model="SearchType" size="sm" >
                            <option value="1">Search Employer by Registration No.</option>
                            <option value="2">Search Employer by Name</option>
                        </b-form-select>
                        </b-input-group-prepend>
                        <b-form-input v-model="SearchWord"></b-form-input>

                        <b-input-group-append>
                            <b-btn class="float-right" size="sm" variant="secondary" @click="Search">Search</b-btn>
                        </b-input-group-append>

                      </b-input-group>
                    </b-col>
                    <b-col>
                      <!-- <b-btn variant="info" to = "/register" class="float-right" size="sm">Register New Employer</b-btn> -->
                    </b-col>
                </b-row>
                <hr/>
                <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;"  class="mt-2">
                <p style="font-size: 17px;color:#2284ab;">Employer Details</p>
                <b-row align-h="center">
                    <b-col>
                        <b-table show-empty head-variant="dark"
                                    stacked="md"
                                    bordered
                                    striped
                                    :items="employers"
                                    :fields="fields"
                                    :current-page="currentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    style="font-size:12px"   
                        >
    
                            <template slot="actions" slot-scope="row">
                              <b-button variant="link" size="sm" @click.stop="viewGuard(row.item, row.index, $event.target)" 
                                  class="mr-1 pt-0 pb-0" v-b-tooltip.hover title="View Employer Details"  v-if="!LockProfile">
                                  <i class="fa fa-eye" style="font-size:16px;color:green"></i>
                              </b-button>
                              <b-button size="sm" @click.stop="deleteMember(row.item, row.index, $event.target)" 
                                  class="mr-1 pt-0 pb-0" variant="outline-danger" v-b-tooltip.hover title="Delete Employer Mapping"  v-if="!LockProfile">
                                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                              </b-button>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col><b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button></b-col>
                </b-row>
            </div>
              <b-modal id="modalViewGuard" title="View Employer Details" size="lg" ok-only ok-title="Close" ok-variant="secondary">
                <EmployerProfile :EmployerID="selectedId"></EmployerProfile>
              </b-modal>
             <b-modal id="modalSearch" title="Search Employer" size="lg">
              <pre> 
                   <b-table show-empty head-variant="dark"
                                    stacked="md"
                                    bordered
                                    striped
                                    :items="searchList"
                                    :fields="fields"
                                    :current-page="currentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    style="font-size:12px"   
                        >
    
                            <template slot="actions" slot-scope="row">
                                <b-button size="sm" @click.stop="selectMember(row.item, row.index, $event.target)" 
                                    class="mr-1 pt-0 pb-0" variant="outline-danger" v-b-tooltip.hover title="Select Employer"  v-if="!LockProfile">
                                    Select
                                </b-button>
                            </template>
                            <template slot="row-details" slot-scope="row">
                                <b-card>
                                    <span>{{row.item.description}}</span>
                                </b-card>
                            </template>
                            </b-table>
              </pre>
            </b-modal>
                        <b-modal id="modalConfirm" title="Are you sure?" size="sm">
              <pre>{{ modalInfo }}</pre>
              <div slot="modal-footer">
                  <b-button variant="danger" @click="modalConfirm" style= "margin-left:5px">Delete</b-button>
                  <b-button variant="info" @click="modalCancel" style= "margin-left:5px">Cancel</b-button>
              </div>
            </b-modal>

            </b-card>
        </div>
    </div>
</b-container>
</template>

<script>
import apis from "@/apis";
import EmployerProfile from "@/components/OtherRegistrations/EmployerProfile";
export default {
  props: ["ExemptionApplicationId"],
  components:{EmployerProfile},
  computed: {
    getRegTyp() {
      let x = this.$store.getters.getRegTyp;
      //console.log(x);
      return x;
    }
  },
  data() {
    return {
      LockProfile: false,
      saved: false,
      form: {
        AgencyID: "00000000-0000-0000-0000-000000000000",
        EmployerID: "00000000-0000-0000-0000-000000000000",
        IsActive: true
      },
      SearchWord: "",
      SearchType: "1",
      employers: [],
      searchList: [],
      fields: [
        { key: "EntityName", label: "Employer Name", sortable: true },
        { key: "RegistrationNumber", label: "Registration No", sortable: true },
        { key: "EmployerAddress", label: "District", sortable: true },
        { key: "actions", label: "-" }
      ],
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: "",
      selectedId: "",
      saved: false
    };
  },
  methods: {
    onClickButton() {

      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    viewGuard(item, index, button) {
      this.selectedId = item.EmployerRegistraionID;
      this.$root.$emit("bv::show::modal", "modalViewGuard");
    },
    Search() {
      this.showDismissibleAlert = false;
      if (this.SearchWord == "") {
        this.alertText = "Please enter the search criteria";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        return;
      } else if(this.SearchType==1 && !Number.isInteger(parseInt(this.SearchWord))){
        this.alertText = "Please enter Numeric value";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        return;
      }
      var promise = apis.searchEmployer(this.SearchWord, this.SearchType);

      promise
        .then(response => {
          if (response.status == 200) {
            this.searchList = response.body;
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });

      this.$root.$emit("bv::show::modal", "modalSearch");
    },
    getAgencyMapping(RegType) {
      var userinfo = this.$store.getters.loggedUser;
    //   alert(this.ExemptionApplicationId);
      let promise = apis.getExemptionApplicationEmployerMapping(this.ExemptionApplicationId,userinfo.UserId);

      promise
        .then(response => {
          if (response.status == 200) {
            this.employers = response.body;
            if(this.employers.length > 0){
              this.saved=true;
            }
            else{
              this.saved=false;
            }
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    //Add Mapping
    selectMember(item, index, target) {
      var userinfo = this.$store.getters.loggedUser;
      this.form.EmployerID = item.EmployerID;
      this.form.AgencyID = userinfo.UserId;
      this.form.IsActive = true;
      //alert(this.form);
      let promise = apis.updateAgencyEmployerMapping(this.form);

      promise
        .then(response => {
          //("Response", response.body);
          if (response.status == 200) {
            
            this.alertText = "Record Added Successfully.";
            this.getAgencyMapping(11);
            this.showDismissibleAlert = true;
            this.variant = "success";
            this.isLoading = false;
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      this.$root.$emit("bv::hide::modal", "modalSearch");
    },

    //Delte Mapping post confirmation

    deleteMember(item, index, button) {
      this.form.AgencyID = item.AgencyID;
      this.form.EmployerID = item.EmployerID;
      this.form.IsActive = false;
      let info = "You want to delete record for:" + "\n" + item.EntityName;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    modalCancel() {
      this.onReset();
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      let promise = apis.updateAgencyEmployerMapping(this.form);

      promise
        .then(response => {

          if (response.status == 200 && response.body == "1") {
            this.alertText = "Record removed Successfully.";
            this.getAgencyMapping(11);
            this.showDismissibleAlert = true;
            this.variant = "success";
            this.isLoading = false;
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    }
  },
  mounted() {
    // alert(this. ExemptionApplicationId);
    this.getAgencyMapping(11);
  }
};
</script>

<style scoped>
.body-wrapper {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  -webkit-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
}

.body-title {
  padding: 15px 25px;
  background: #fcfcfc;
  border-bottom: solid 2px #aaa;
}

.body-content {
  padding: 25px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/AgencyExemption/ExemptionApplicationEmployerMap.vue